// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import Subscription from '@/extend/classes/Subscription';
import Owner from '@/extend/classes/Owner';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Offres
export class SubscriptionRequired {
  // Texte affiché dans le dialogue
  public html: string;
  // Type d'abonnement minimum requis pour la fonction
  public minTypeId: number;
  // Permet de résilier un abonnement
  public terminateId: number;

  constructor() {
    this.html = '';
    this.minTypeId = 0;
    this.terminateId = 0;
  }
}

export default class SubscriptionType  {
  // Identifiant unique
  public id: number;
  // Nom
  public label: string;
  // Description
  public description: string;
  // Peut être souscrit
  public canSubscribe: boolean;
  // Prix mensuel
  public mensuel: number;
  // Frais de dossier
  public dossier: number;
  // Frais de traitement min
  public minTraitement: number;
  // Frais de traitement max
  public maxTraitement: number;
  // Taux des frais de traitement en %
  public tauxTraitement: number;
  // frais de signature EN
  public fraisSignatureEn: number;
  // frais de modification
  public fraisModification: number;
  // frais de suppression
  public fraisSuppression: number;
  // Max paies/an
  public maxPaies: number;
  // Suivi des licences
  public hasLicenceFollow: boolean;
  // Gère conventions
  public hasConvention: boolean;
  // Contrat custom
  public hasCustomContrat: boolean;
  // Gère signataires
  public hasSignatory: boolean;
  // url info abonnement
  public url: string;
  // Description
  public descriptionHtmlId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.label = '';
    this.description = '';
    this.canSubscribe = false;
    this.mensuel = 0;
    this.dossier = 0;
    this.minTraitement = 0;
    this.maxTraitement = 0;
    this.tauxTraitement = 0;
    this.fraisSignatureEn = 0;
    this.fraisModification = 0;
    this.fraisSuppression = 0;
    this.maxPaies = 0;
    this.hasLicenceFollow = false;
    this.hasConvention = false;
    this.hasCustomContrat = false;
    this.hasSignatory = false;
    this.url = '';
    this.descriptionHtmlId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: SubscriptionType): SubscriptionType {
    const newSubscriptionType: SubscriptionType = new SubscriptionType();
    newSubscriptionType.id = obj.id;
    newSubscriptionType.label = obj.label;
    newSubscriptionType.description = obj.description;
    newSubscriptionType.canSubscribe = obj.canSubscribe;
    newSubscriptionType.mensuel = obj.mensuel;
    newSubscriptionType.dossier = obj.dossier;
    newSubscriptionType.minTraitement = obj.minTraitement;
    newSubscriptionType.maxTraitement = obj.maxTraitement;
    newSubscriptionType.tauxTraitement = obj.tauxTraitement;
    newSubscriptionType.fraisSignatureEn = obj.fraisSignatureEn;
    newSubscriptionType.fraisModification = obj.fraisModification;
    newSubscriptionType.fraisSuppression = obj.fraisSuppression;
    newSubscriptionType.maxPaies = obj.maxPaies;
    newSubscriptionType.hasLicenceFollow = obj.hasLicenceFollow;
    newSubscriptionType.hasConvention = obj.hasConvention;
    newSubscriptionType.hasCustomContrat = obj.hasCustomContrat;
    newSubscriptionType.hasSignatory = obj.hasSignatory;
    newSubscriptionType.url = obj.url;
    newSubscriptionType.descriptionHtmlId = obj.descriptionHtmlId;
    newSubscriptionType.createId = obj.createId;
    newSubscriptionType.failed = obj.failed;
    newSubscriptionType.canUpdate = obj.canUpdate;
    newSubscriptionType.canDelete = obj.canDelete;
    newSubscriptionType.display = obj.display;
    newSubscriptionType.notifDefType = obj.notifDefType;
    return newSubscriptionType;
  }

  public toJsonSubscriptionType (): string {
    const json = {
      label: this.label,
      description: this.description,
      canSubscribe: this.canSubscribe,
      mensuel: this.mensuel,
      dossier: this.dossier,
      minTraitement: this.minTraitement,
      maxTraitement: this.maxTraitement,
      tauxTraitement: this.tauxTraitement,
      fraisSignatureEn: this.fraisSignatureEn,
      fraisModification: this.fraisModification,
      fraisSuppression: this.fraisSuppression,
      maxPaies: this.maxPaies,
      hasLicenceFollow: this.hasLicenceFollow,
      hasConvention: this.hasConvention,
      hasCustomContrat: this.hasCustomContrat,
      hasSignatory: this.hasSignatory,
      url: this.url,
      descriptionHtmlId: this.descriptionHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromSubscriptionType (obj: SubscriptionType): void {
    this.id = obj.id;
    this.label = obj.label;
    this.description = obj.description;
    this.canSubscribe = obj.canSubscribe;
    this.mensuel = obj.mensuel;
    this.dossier = obj.dossier;
    this.minTraitement = obj.minTraitement;
    this.maxTraitement = obj.maxTraitement;
    this.tauxTraitement = obj.tauxTraitement;
    this.fraisSignatureEn = obj.fraisSignatureEn;
    this.fraisModification = obj.fraisModification;
    this.fraisSuppression = obj.fraisSuppression;
    this.maxPaies = obj.maxPaies;
    this.hasLicenceFollow = obj.hasLicenceFollow;
    this.hasConvention = obj.hasConvention;
    this.hasCustomContrat = obj.hasCustomContrat;
    this.hasSignatory = obj.hasSignatory;
    this.url = obj.url;
    this.descriptionHtmlId = obj.descriptionHtmlId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareSubscriptionType (value: SubscriptionType): boolean {
    return (this.toJsonSubscriptionType() == value.toJsonSubscriptionType());
  }

  public cloneSubscriptionType (): SubscriptionType {
    return SubscriptionType.fromJson(this);
  }

  public createForStoreSubscriptionType (): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptiontypes/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSubscriptionType(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreSubscriptionType (): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/subscriptiontypes/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSubscriptionType(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreSubscriptionType (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/subscriptiontypes/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptiontypes/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static subscribe (subscription: Subscription): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptiontypes/subscribe', subscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static change (owner: Owner): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptiontypes/change', owner, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(SubscriptionType.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/SubscriptionTypes/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = SubscriptionType.fromJson(listData.reccords[0] as SubscriptionType);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<SubscriptionType> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/SubscriptionTypes/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = SubscriptionType.fromJson(listData.reccords[0] as SubscriptionType);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(subscriptionTypes: SubscriptionType[]) {
  }
}
